import { render, staticRenderFns } from "./LoginCom.vue?vue&type=template&id=b9c8ddc2&"
import script from "./LoginCom.vue?vue&type=script&lang=js&"
export * from "./LoginCom.vue?vue&type=script&lang=js&"
import style0 from "./LoginCom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports